import colors from "./colors";

const { grey, white, background, primary, text } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
    "@media (prefers-reduced-motion: reduce)": { scrollBehavior: "auto" },
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
  },

  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  "a, a:link, a:visited": {
    textDecoration: "none",
    transition: "color 0.15s cubic-bezier(0.33, 0, 0.67, 1)",
  },

  "a:not([class]), a:not([class]):link, a:not([class]):visited": {
    color: primary.main,
    "&:hover": { textDecoration: "underline" },
  },

  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: primary.main,
    transition: "color 0.15s cubic-bezier(0.33, 0, 0.67, 1)",

    "&:hover, &:focus": {
      color: primary.focus,
    },
  },

  "::-webkit-scrollbar": {
    width: "12px",
    height: "12px",
    backgroundColor: "transparent",
  },

  "::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },

  "::-webkit-scrollbar-thumb": {
    backgroundColor: grey[500],
    borderRadius: "4px",
    border: "2px solid transparent",
    backgroundClip: "content-box",

    "&:hover": {
      backgroundColor: grey[600],
    },
  },

  "::-webkit-scrollbar-corner": {
    backgroundColor: background.default,
  },

  "*": {
    scrollbarWidth: "thin",
    scrollbarColor: `${grey[500]} transparent`,
  },

  "::selection": {
    backgroundColor: primary.main,
    color: background.default,
  },

  "::-moz-selection": {
    backgroundColor: primary.main,
    color: background.default,
  },

  ":focus-visible": {
    outline: `2px solid ${primary.main}`,
    outlineOffset: "2px",
    borderRadius: "4px",
  },

  "button, input, textarea, select": {
    transition: "all 0.15s cubic-bezier(0.33, 0, 0.67, 1)",
  },

  ".MuiCard-root": {
    transition: "all 0.15s cubic-bezier(0.33, 0, 0.67, 1)",
  },

  body: {
    fontFamily: '"Segoe UI Variable Text", "Segoe UI Variable", "Segoe UI", system-ui, -apple-system, "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: "14px",
    lineHeight: "1.6",
    color: text.primary,
    backgroundColor: background.default,
  },

  ".MuiButtonBase-root.Mui-focusVisible, .MuiButton-root:focus-visible, .MuiIconButton-root:focus-visible": {
    outline: `2px solid ${primary.main}`,
    outlineOffset: "1px",
    boxShadow: `0 0 0 1px ${background.paper}`,
  },

  "@media (prefers-reduced-motion: reduce)": {
    "*, *::before, *::after": {
      animationDuration: "0.01ms !important",
      animationIterationCount: "1 !important",
      transitionDuration: "0.01ms !important",
    },
  },

  ".spinner-overlay": {
    backdropFilter: "blur(4px)",
    backgroundColor: "rgba(11, 17, 32, 0.85)",
  },

  ".spinner": {
    borderColor: `${grey[300]} ${grey[300]} ${primary.main} ${grey[300]}`,
  },
};

export default globals;
